import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {useActionBlockPreviewProps} from "~/cabinet/vue/client/events/action/types/useActionBlockPreview";
import ActionBlockPreviewItem from "~/cabinet/vue/client/events/action/types/ActionBlockPreviewItem.vue";
import {computed} from "vue";
import {
    DataProviderEntitySaveActionDescription
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/DataProviderEntitySaveActionDescription";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "AbstractDataProviderActionBlockPreview"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
        ...useActionBlockPreviewProps<DataProviderEntitySaveActionDescription>()
    },
  setup(__props) {

let props = __props;

let links = computed(() => {
    let result: string[] = [];
    if (props.params.links) {
        for (let link of props.params.links) {
            let linkId = link.entityTypeId;
            let descr = props.actionDescription.frontendParams.linkEntityTypes.find(type => type.id == linkId)?.descr;
            if (descr) {
                result.push(descr);
            }
        }
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ActionBlockPreviewItem, { label: "Интеграция" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(props).actionDescription.frontendParams.authDescr), 1)
      ]),
      _: 1
    }),
    (_unref(links).length)
      ? (_openBlock(), _createBlock(ActionBlockPreviewItem, {
          key: 0,
          label: "Связанные сущности"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(links).join(", ")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})